import Splide from '@splidejs/splide';

export default function CategoryListing() {
  const list = document.getElementById('CategoryListing');

  if (!list) return;

  const config = {
    type: 'slide',
    arrows: false,
    pagination: false,
    destroy: true,
    perPage: 2,
    perMove: 2,
    padding: { right: '1rem' },
    breakpoints: {
      768: {
        destroy: false,
        gap: '12px'
      }
    }
  };

  new Splide(list, config).mount();
}
